import { Button, TextField } from 'components';
import { usePartnerAdmin } from 'hooks/usePartnersAdmin';

import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';

export const PartnerSearchBar = () => {
  const { uf, setUf, query, setQuery, getPartnersCb } = usePartnerAdmin();

  const handleChangeUf = (event: any) => {
    setUf(event.target.value);
  };

  const handleChangeQuery = (event: any) => {
    setQuery(event.target.value);
  };

  return (
    <Grid container spacing={1} justifyContent="flex-end">
      <Grid item>
        <TextField
          id="query"
          label="Busque aqui"
          variant="outlined"
          value={query}
          onChange={handleChangeQuery}
        />
      </Grid>

      {false && (
        <Grid item>
          <FormControl variant="outlined" sx={{ minWidth: 120 }}>
            <InputLabel id="bondLabel">UF</InputLabel>
            <Select
              labelId="bondLabel"
              id="bondSelect"
              label="UF"
              value={uf}
              onChange={handleChangeUf}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="AC">AC</MenuItem>
              <MenuItem value="AL">AL</MenuItem>
              <MenuItem value="AM">AM</MenuItem>
              <MenuItem value="AP">AP</MenuItem>
              <MenuItem value="BA">BA</MenuItem>
              <MenuItem value="CE">CE</MenuItem>
              <MenuItem value="DF">DF</MenuItem>
              <MenuItem value="ES">ES</MenuItem>
              <MenuItem value="GO">GO</MenuItem>
              <MenuItem value="MA">MA</MenuItem>
              <MenuItem value="MG">MG</MenuItem>
              <MenuItem value="MS">MS</MenuItem>
              <MenuItem value="MT">MT</MenuItem>
              <MenuItem value="PA">PA</MenuItem>
              <MenuItem value="PB">PB</MenuItem>
              <MenuItem value="PE">PE</MenuItem>
              <MenuItem value="PI">PI</MenuItem>
              <MenuItem value="PR">PR</MenuItem>
              <MenuItem value="RJ">RJ</MenuItem>
              <MenuItem value="RN">RN</MenuItem>
              <MenuItem value="RO">RO</MenuItem>
              <MenuItem value="RR">RR</MenuItem>
              <MenuItem value="SC">SC</MenuItem>
              <MenuItem value="SE">SE</MenuItem>
              <MenuItem value="SP">SP</MenuItem>
              <MenuItem value="TO">TO</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}

      <Grid item>
        <Button
          size="large"
          sx={{ minHeight: 56, color: '#FFF' }}
          onClick={() => {
            getPartnersCb(true);
          }}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
};

